const schema = {
    signature: {
        "label": "Signature:",
        "placeholder": "Please sign",
        "required": "true"
    }
};

export default schema;